export const blockIconsHomeDetectorAlarmNew = (
	<span className='material-symbols-outlined'>detector_alarm</span>
);
